import { z } from 'zod';
import { eventSchema } from './envelope';

export const TRANSLATION_USAGE_RECORDED_V1 = 'translation.usage.recorded.v1' as const;

/**
 * Wat er vertaald is, geteld per dag en per bedrijf.
 *
 * Per dag en niet per vertaling: een bericht aan vijfentwintighonderd mensen in acht talen zou
 * anders duizenden events opleveren voor één handeling, en dan is er geen verbruik meer te zien
 * tussen de ruis. Hier hangt straks de facturatie aan (Stap 30) en een waarschuwing bij een
 * bedrijf dat plots tien keer zo veel vertaalt.
 */
export const translationUsageRecordedV1Schema = eventSchema({
  /** De dag als `YYYY-MM-DD`, in de tijdzone van het bedrijf. */
  day: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  characters: z.number().int().min(0),
  requests: z.number().int().min(0),
});
export type TranslationUsageRecordedV1 = z.infer<typeof translationUsageRecordedV1Schema>;
